module.exports = __webpack_public_path__ + "static/media/217-india.613bdf82.svg";